import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

interface BetaTagProps {
  className?: string
}

const BetaTag: FunctionComponent<BetaTagProps> = ({ className }) => (
  <Beta className={className}>BETA</Beta>
)

export default BetaTag

export const Beta = styled.div`
  width: fit-content;
  padding: 0px 8px;
  background: #e6f7ff;
  border-radius: 10px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #1890ff;
`
